module.exports = __webpack_public_path__ + "img/photo-0107.848d0ebf.jpg";